import {
  Button,
  Form,
  FormGroup,
  Grid,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalMain,
  Option,
  Select,
} from "@ligo/layout-design-core";
import { ModalParamsType } from "models";
import { useEffect } from "react";
import useViewModel from "./viewModel";

const SelectProject = (args: ModalParamsType) => {
  const { open, onClose } = args;
  const vm = useViewModel(args);
  const { projectOpts, codeSoftphoneOpts, selectProject } = vm;
  const { errors, pIdProject, pIdSoftphone, hasSoftphoneSelect } = vm;
  const { t, onSubmit, onOpen } = vm;
  const { changeSelectProject, setValue } = vm;

  useEffect(() => {
    onOpen();
  }, [onOpen]);

  return (
    <Modal show={open}>
      <Form onSubmit={onSubmit}>
        <ModalHeader
          title={t(`selectProject.title`)}
          onClose={pIdProject ? onClose : undefined}
        />
        <ModalMain $noOverflow>
          <Grid $container $spacing={1.6}>
            <Grid $item $xs={12}>
              <FormGroup
                required
                label={t("labels.project")}
                error={t(errors?.project?.message ?? "")}
              >
                <Select
                  $fullWidth
                  value={selectProject}
                  placeholder={t("select")}
                  onChange={(value) => changeSelectProject(value as number)}
                >
                  {projectOpts?.map(({ DeProject, IdProject }) => (
                    <Option key={IdProject} value={IdProject}>
                      {DeProject}
                    </Option>
                  ))}
                </Select>
              </FormGroup>
            </Grid>
            {hasSoftphoneSelect && (
              <Grid $item $xs={12}>
                <FormGroup
                  label={t("labels.softphone")}
                  error={t(errors?.softphone?.message ?? "")}
                >
                  <Select
                    hasClear
                    $fullWidth
                    placeholder={t("select")}
                    defaultValue={pIdSoftphone}
                    onChange={(value) => setValue("softphone", value as number)}
                  >
                    {codeSoftphoneOpts?.map(({ label, codeSoftphone }) => (
                      <Option key={codeSoftphone} value={codeSoftphone}>
                        {label}
                      </Option>
                    ))}
                  </Select>
                </FormGroup>
              </Grid>
            )}
          </Grid>
        </ModalMain>
        <ModalFooter>
          {pIdProject && (
            <Button $outlined onClick={onClose}>
              {t("cancel")}
            </Button>
          )}
          <Button type="submit">{t("select")}</Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default SelectProject;
